/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../app/modules/auth'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {ID, QUERIES} from '../../../helpers'
import {useQueryClient} from 'react-query'
import {IWebsite} from '../../../../app/pages/websites/core/_models'
import {getImpersonationToken} from '../../../../app/pages/users/core/_requests'

const BASE_URL = `${process.env.REACT_APP_HTTP}${process.env.REACT_APP_URL}`
const OldAdmin: FC = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  const queryClient = useQueryClient()
  const websitesData: IWebsite[] | undefined = queryClient.getQueryData(QUERIES.WEBSITES_LIST)
  const userWebsites: IWebsite[] | undefined = websitesData?.filter((website) => currentUser?.websites?.some((userWebsite) => userWebsite.id === website.id))
  const [loading, setLoading] = useState(false)

  const impersonateUser = (id: ID, website: IWebsite)=> {
    setLoading(true)
    getImpersonationToken(id)
      .then(({data}) => {
        let host = website.externalUsersApi || ('https://'+website.host);
        window.open(host+'/admin/?token='+data.authToken, '_blank')
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  if (userWebsites?.length) {
    return (
      <MenuInnerWithSub
        title={intl.formatMessage({id: 'MENU.OLD_ADM', defaultMessage: 'Old dashboard'})}
        to='/old-admin'
        menuPlacement='bottom-start'
        menuTrigger={`{default:'click', lg: 'hover'}`}
      >
        {userWebsites && userWebsites
          .map((item, index) => (
            <div className='menu-item me-lg-1' key={index}>
              <a className={`menu-link py-3`} onClick={()=>impersonateUser(currentUser?.id, item)} key={index}>
                {item.faviconUrl && (
                  <span className='menu-icon'>
                    <img
                      alt=''
                      className='rounded-circle w-25px me-2'
                      src={`${BASE_URL}${item.faviconUrl}`}
                    />
                  </span>
                )}
                <span className='menu-title'>{item.host}</span>
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </a>
            </div>
          ))
        }
      </MenuInnerWithSub>
    )
  }
  return null;
}

export {OldAdmin}
